import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle } from '@paige/ui';
import './insights.css';

export interface UsageCardProps {
  id?: string | undefined;
  title: string;
  /** The sentence under the title: what the picture counts, and in which zone. */
  note: ReactNode;
  /** The range switch, top right. */
  controls?: ReactNode;
  /** When there is nothing to draw, the sentence that says so instead of an empty picture. */
  empty?: string | null | undefined;
  children: ReactNode;
}

/** The frame every usage chart sits in: title, note, range switch, then the picture or why not. */
export function UsageCard({
  id,
  title,
  note,
  controls,
  empty,
  children,
}: UsageCardProps): ReactNode {
  return (
    <Card className="ad-vol__card" id={id}>
      <CardHeader className="ad-vol__head">
        <div>
          <CardTitle>{title}</CardTitle>
          <span className="ad-small">{note}</span>
        </div>
        {controls}
      </CardHeader>
      {empty ? <p className="ad-vol__empty">{empty}</p> : children}
    </Card>
  );
}
